// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0b87a891","455":"4076082f","578":"1089e743","977":"16481e05"}[chunkId] + ".chunk.js";
};